<div id="loseorwin">
  <p id="player">{{id}}</p>
  <p id="score">{{score}}</p>
</div>
